import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  let apiUrl = `/api/produce-crafts`;
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_STD_CRAFT_COMPARE',
    manual: false,
  });

  useEffect(() => {
    if (params) {
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          apiUrl += '?';
        } else {
          apiUrl += '&';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        apiUrl += `${key}=${params[key]}`;
      });
      exec(apiUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [data || [], exec, isRequestSuccessed];
});
